var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.progressState === 'full')?_c('icon',{class:[
    { 'is-active' : _vm.isActive, },
    _vm.progressState,
  ],attrs:{"name":"check-circle"}}):_c('span',{class:[
    { 'is-active': _vm.isActive, },
    _vm.progressState,
    'progress-icon',
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }